import { RootState } from 'src/store';

export const selectIsSidebarShow = (state: RootState): boolean => state.sidebar;
